import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
export default function FiltersSection({ state, dispatch }) {
  return (
    <Box>
      <Typography variant='caption' color='text.secondary' sx={{ display: 'block', mb: 1 }}>
        Note: seeded data is limited. Try searching IST → SJJ / VIE → IST with a
        search window of 01.05.2026 – 31.05.2026.
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
        <TextField
          label='Max total price €'
          type='number'
          value={state.filters.maxTotalPrice}
          onChange={(e) =>
            dispatch({
              type: 'SET_FILTER',
              field: 'maxTotalPrice',
              value: e.target.value,
            })
          }
          fullWidth
          size='small'
          slotProps={{
            htmlInput: { min: 0 },
          }}
        />

        <TextField
          label='Max work days used'
          type='number'
          value={state.filters.maxWorkDaysUsed}
          onChange={(e) =>
            dispatch({
              type: 'SET_FILTER',
              field: 'maxWorkDaysUsed',
              value: e.target.value,
            })
          }
          fullWidth
          size='small'
          slotProps={{
            htmlInput: { min: 0, max: 30 },
          }}
        />
      </Stack>
    </Box>
  );
}
